import { Box, SxProps, Theme } from "@mui/material";
import Icons from "@/assets";

interface PlaceThumbnailProps {
  src?: string;
  alt?: string;
  size?: number | string | { xs: string | number; sm: string | number };
  borderRadius?: string | number;
  onClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
  sx?: SxProps<Theme>;
}

const PlaceThumbnail = ({ 
  src, 
  alt = "Place", 
  size = 48, 
  borderRadius = "8px", 
  onClick,
  sx 
}: PlaceThumbnailProps) => {
  const isResponsiveSize = typeof size === 'object';
  
  const boxStyles: SxProps<Theme> = {
    height: isResponsiveSize ? size : size,
    width: isResponsiveSize ? size : size,
    borderRadius,
    objectFit: "cover" as const,
    border: "1px solid rgba(0,0,0,0.08)",
    flexShrink: 0,
    ...sx,
  };

  return (
    <Box
      component="img"
      src={src || Icons.Building}
      alt={alt}
      onClick={onClick}
      onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
        e.currentTarget.src = Icons.Building;
      }}
      sx={boxStyles}
    />
  );
};

export default PlaceThumbnail;
